// extracted by mini-css-extract-plugin
export default {"auth_input_label":"styled_auth_input_label__R+ZY1","auth_input":"styled_auth_input__2kxSe","auth_input_error_text":"styled_auth_input_error_text__6PDJl"};